module.exports = __webpack_public_path__ + "img/UTFREM-8.8e6cc541.jpg";